export const vehiclesColumnsData = [
  {
    name: 'Technician ID',
    filter: true,
    show: true,
    id: 'technician_id',
  },
  // {
  //   name: 'Sub customer',
  //   filter: false,
  //   show: true,
  //   id: 'customer_name',
  // },
  {
    name: 'Location',
    filter: false,
    show: true,
    id: 2,
  },
  {
    name: 'Job status',
    filter: false,
    show: true,
    id: 'status',
  },
  {
    name: 'Installed date',
    filter: true,
    show: true,
    id: 'job_datetime',
  },
  {
    name: 'PO #',
    filter: true,
    show: true,
    id: 'purchase_order',
  },
  {
    name: 'Verification Key',
    filter: true,
    show: true,
    id: 'verification_key',
  },
  {
    name: 'VIN',
    filter: false,
    show: true,
    id: 'vin',
  },
  {
    name: 'Vehicle label',
    filter: false,
    show: true,
    id: 'vehicle_label',
  },
  {
    name: 'Year',
    filter: false,
    show: true,
    id: 'year',
  },
  {
    name: 'Make',
    filter: false,
    show: true,
    id: 'make',
  },
  {
    name: 'Model',
    filter: false,
    show: true,
    id: 'model',
  },
  {
    name: 'Odometer',
    filter: false,
    show: true,
    id: 'odometer',
  },
  {
    name: 'GPS serial #',
    filter: false,
    show: true,
    id: 12,
  },
  {
    name: 'Camera serial #',
    filter: false,
    show: true,
    id: 13,
  },
  {
    name: 'Removed serial',
    filter: false,
    show: true,
    id: 14,
  },
  {
    name: 'HRS',
    filter: false,
    show: true,
    id: 'time',
  },
  {
    name: 'Price $',
    filter: false,
    show: true,
    id: 'items_sum_price',
  },
  {
    name: 'Installed Notes',
    filter: false,
    show: true,
    id: 17,
  },
  {
    name: 'Invoice #',
    filter: false,
    show: true,
    id: 'payout_id',
  },
  {
    name: 'File',
    filter: false,
    show: true,
    id: 19,
  },
]

export const showingData = [
  {
    label: '10',
    value: 10
  },
  {
    label: '25',
    value: 25
  },
  {
    label: '50',
    value: 50
  },
  {
    label: '100',
    value: 100
  }
]
